// @flow
import React, { PureComponent } from 'react';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { STATUS_LOADING, STATUS_FAILURE } from 'constants/statusConstants';
import type { Status } from 'types/Status';
import type { JoueurType } from 'types/Joueur';
import type { BlocContent } from 'types/NewsletterBloc';
import type { FullUserType, EditProfileValueType } from 'types/User';
import Sidebar from 'components/sidebar/Sidebar';
import Loading from 'components/fragments/Loading';
import BackgroundImage from 'components/fragments/BackgroundImage';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import Breadcrumb from 'components/fragments/Breadcrumb';
import PlayedGames from 'components/team/TeamPlayer/PlayedGames';
import TeamMenuDropdownMenu from 'components/teammenu/TeamMenuDropdownMenu';
import { Link } from 'react-router-dom';
import { formatFullDate } from 'utils/dateUtils';
import CardClubJoueur from 'containers/fragments/card/CardClubJoueurContainer';
import { youtubeDurationToTime } from 'utils/socialUtils';
import { getMetaBySlug } from 'utils/seoUtils';
import { handleTagEvent } from 'utils/tagManagerUtils';
import { Redirect } from 'react-router-dom';
import 'components/team/team.css';
export type StateProps = {
  title: string,
  featured_media: {
    src: string,
    legend: string
  },
  sidebar_content: BlocContent[],
  joueur: JoueurType,
  status: Status,
  statusPlayer: Status,
  userPref: FullUserType,
  error: string
};

type HistoryProps = {
  history: any
};

type OwnProps = {
  match: {
    params: {
      joueur: string,
      slug: string,
      typeRugby: string
    }
  }
};

export type DispatchProps = {
  fetchPageList: (slug: string) => void,
  fetchJoueur: (joueur: string) => void,
  resetJoueur: () => void,
  postUserPref: (action: string, value: EditProfileValueType, token: string) => void,
  displayModal: (modalObject: string, content: Object) => void
};

type Props = StateProps & OwnProps & DispatchProps & HistoryProps;
type State = {
  isFavoritePlayer: boolean
};

class TeamPlayer extends PureComponent<Props, State> {
  state: State = {
    isFavoritePlayer: false
  };

  static getDerivedStateFromProps(props, state) {
    const { isFavoritePlayer } = state;
    const { joueurs_favoris } = props.userPref;
    const includedInFavorites = joueurs_favoris.includes(props.joueur.id);

    if (isFavoritePlayer !== includedInFavorites) {
      return {
        isFavoritePlayer: includedInFavorites
      };
    }
    return null;
  }

  componentDidMount() {
    this.props.fetchJoueur(this.props.match.params.joueur);
    this.props.fetchPageList(this.props.match.params.slug);
    const { statusPlayer, postUserPref } = this.props;
    const favPlayerInQueue = localStorage.getItem('favPlayer');

    if (statusPlayer === STATUS_FAILURE) {
      this.props.history.push('/404');
    }
    if (favPlayerInQueue) {
      postUserPref('joueurs-favoris-add', favPlayerInQueue, this.props.userPref.token);
      localStorage.removeItem('favPlayer');
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { joueur, slug } = this.props.match.params;
    const {
      statusPlayer,
      userPref: { identifie }
    } = this.props;
    const {
      userPref: { identifie: prevIdentifie }
    } = prevProps;

    if (prevProps.match.params.joueur !== joueur || prevProps.match.params.slug !== slug) {
      this.props.fetchJoueur(joueur);
      this.props.fetchPageList(this.props.match.params.slug);
    }
    if (statusPlayer === STATUS_FAILURE) {
      this.props.history.push('/404');
    }
    if (prevIdentifie !== identifie && !identifie) {
      alert('Votre session a expiré');
    }
  }

  componentWillUnmount() {
    const { resetJoueur } = this.props;

    resetJoueur();
  }

  teamChange(team: Object) {
    this.props.history.push(team.link);
  }

  renderTrueBlocs = (blocs: BlocContent[]): any => {
    return blocs.map((blocFigure, index) => <ContentBloc key={index} {...blocFigure} />);
  };

  renderNewsPlayer = () => {
    const { joueurs_favs_news, logo } = this.props.joueur;
    return joueurs_favs_news.map(news => {
      const newsTitle = news.title.replace('&nbsp;', '');

      return (
        <li key={`actualite}-${news.id}`} className="news news--list news--listSmall">
          <a href={news.link} alt={newsTitle} target="_blank" rel="noopener noreferrer">
            <div className="news__thumbnail">
              <div className="badge--mini">
                {/* <div className="badge--mini__desc">{tag.name}</div> */}
                <div className="badge__circle">
                  <div className="badge__inner-circle">
                    <div className="badge__inner-image" style={{ backgroundImage: `url(${logo})` }}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="news__body">
              <span className="news__title ft-h5">{newsTitle}</span>
              <p className="ft-h6">
                <span className="news__date">{formatFullDate(new Date(news.date.replace(' ', 'T')))}</span>
              </p>
            </div>
          </a>
        </li>
      );
    });
  };

  renderYoutube = () => {
    const { videos } = this.props.joueur;
    return videos.map((c, index) => {
      if (index < 2) {
        return (
          <Link
            key={index}
            to={`/ffr-tv-player/${c.id}`}
            className="box card card--video"
            title="Voir cette vidéo sur la FFR TV"
          >
            {c.snippet.thumbnails && (c.snippet.thumbnails.standard || c.snippet.thumbnails.high) && (
              <div
                className="card__thumbnail img-blue-dark"
                style={{
                  backgroundImage: `url(${
                    c.snippet.thumbnails.standard ? c.snippet.thumbnails.standard.url : c.snippet.thumbnails.high.url
                  })`
                }}
              >
                <img
                  src={
                    c.snippet.thumbnails.standard ? c.snippet.thumbnails.standard.url : c.snippet.thumbnails.high.url
                  }
                  alt=""
                />
              </div>
            )}
            <div className="card__footer">
              <span className="link-icon link-icon--medium is-dark">
                <i className="icon icon-play"></i>
              </span>
              <h5 className="card__title ft-truncat" dangerouslySetInnerHTML={{ __html: c.snippet.description }} />
              <p className="card__date">{c.contentDetails && youtubeDurationToTime(c.contentDetails.duration)}</p>
            </div>
            <div className="card__type">
              <span className="label label--red">{c.snippet.tags && c.snippet.tags[0]}</span>
            </div>
          </Link>
        );
      }
      return null;
    });
  };

  renderHistoriqueCard = historique => {
    return historique.map((club, index) => {
      return (
        <div key={index}>
          <CardClubJoueur
            link={club.link}
            name={club.club}
            embleme={club.embleme}
            saison={club.saisons}
            age={club.age}
          />
        </div>
      );
    });
  };

  renderHistorique = historique => {
    if (historique && historique.length > 0) {
      return (
        <div>
          <h2 className="mb-3 mt-8">Ses clubs</h2>
          {this.renderHistoriqueCard(historique)}
        </div>
      );
    } else {
      return false;
    }
  };

  setFavoritePlayer = () => {
    const {
      postUserPref,
      joueur: { id, title, prenom, nom },
      userPref,
      userPref: { identifie },
      error,
      displayModal
    } = this.props;
    const { isFavoritePlayer } = this.state;
    const redirection = window.location.pathname;

    const nomJoueur = prenom && nom ? prenom + ' ' + nom : title;
    if (error === 'rest_logged_user' || !identifie) {
      localStorage.setItem('favPlayer', `${id}`);
      displayModal('MODAL_ADD_FAVORITE_PLAYER', { title: nomJoueur, redirection });
    } else {
      if (isFavoritePlayer) {
        this.setState({ isFavoritePlayer: false });
        displayModal('MODAL_REMOVE_FAVORITE', { title: nomJoueur, id });
      } else {
        postUserPref('joueurs-favoris-add', `${id}`, this.props.userPref.token);
        handleTagEvent('ajout_favoris', nomJoueur, redirection, userPref)();
      }
    }
  };

  render() {
    const {
      joueur: {
        title,
        content,
        poste,
        dateNaissance,
        genre,
        numInternational,
        nombre_selections,
        matchs_joues,
        equipes,
        videos,
        logo,
        historique,
        joueurs_favs_news,
        joueurs_tags_names,
        selections_origine
      },
      sidebar_content,
      featured_media,
      statusPlayer,
      match: {
        params: { typeRugby, slug }
      }
    } = this.props;
    const { isFavoritePlayer } = this.state;
    const title_team = this.props.title;
    const link_video = 'https://www.youtube.com/channel/UCnH0bSmQqDBfNj9kZzCaINw/search?query=joueur+%3A+' + title;
    let link_actus = '';
    if (joueurs_tags_names.length > 0) {
      link_actus = '/tags/' + joueurs_tags_names[0];
    }
    if (statusPlayer === STATUS_LOADING) {
      return <Loading isBlue backgroundColor={'#013974'} />;
    }
    let equipe_en_cours = [];
    if (equipes.length > 0) {
      /**
       * Recherche de l'équipe en cours
       */
      equipe_en_cours = equipes.filter(equipe => {
        return equipe.title === title_team;
      });
    }

    /**
     * Si pas d'équipe en cours, c'est que nous n'avons pas trouvé l'équipe de
     * l'environnement dans les équipes du joueur en question
     * On redirige donc sur la première équipe du joueur
     */
    if ((!equipe_en_cours || !equipe_en_cours[0]) && equipes[0] && equipes[0].link !== window.location.pathname) {
      return <Redirect to={equipes[0].link} />;
    }
    let title_stats = 'Statistiques';
    let title_selections = 'Sélections';

    const equipe_en_cours_une = equipe_en_cours.length > 0 ? equipe_en_cours[0] : false;

    if (
      genre === 'F' &&
      equipe_en_cours_une &&
      equipe_en_cours_une.type_rugby &&
      equipe_en_cours_une.type_rugby === 'XV'
    ) {
      title_stats = 'Statistiques à partir de juillet 2018';
      title_selections = 'Sélections totales';
    }

    return (
      <>
        <section className="banner banner--compact">
          <div
            className="banner__thumbnail img-blue-dark"
            style={{ backgroundImage: `url(${featured_media.src})` }}
          ></div>
          <div className="container">
            <Breadcrumb
              elements={[
                { name: 'accueil', to: '/' },
                { name: 'Équipes de France', to: '/equipe-de-france' },
                { name: typeRugby.replace(/-/g, ' '), to: '/equipe-de-france/' + typeRugby },
                { name: title_team, to: '/equipe-de-france/' + typeRugby + '/' + slug },
                { name: `L'équipe`, to: '/equipe-de-france/' + typeRugby + '/' + slug + '/joueurs' },
                title
              ]}
              isDark
            />
          </div>
        </section>
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                <article className="player-detail row">
                  <div className="col col-lg-8on9">
                    <div className="row">
                      <div className="col col-lg-8on9 banner-over player-detail__head">
                        <BackgroundImage
                          className="player-portrait mb-3 mb-md-0"
                          illustration={logo}
                          srcset={this.props.joueur.featured_media && this.props.joueur.featured_media.sizes}
                          forceState={'large'}
                        />
                        <div>
                          {genre && (
                            <Link
                              to={'/equipe-de-france/' + typeRugby + '/' + slug + '/joueurs'}
                              className="link-chevron link-chevron--left"
                            >
                              <i className="icon icon-chevron-left"></i>
                              <span>
                                {genre === 'M' ? 'Retour à la liste des joueurs' : 'Retour à la liste des joueuses'}
                              </span>
                            </Link>
                          )}
                          <h1 className="mb-1">{title}</h1>
                          <span className="role mb-3 mb-md-2">{poste.name}</span>
                          <ul>
                            {dateNaissance && dateNaissance !== '' && (
                              <li>
                                <span className="birthdate ft-h5">{genre === 'M' ? 'Né le' : 'Née le'}</span>
                                <p>{dateNaissance}</p>
                              </li>
                            )}
                            {numInternational > 0 && (
                              <li>
                                <span className="number ft-h5">{genre === 'M' ? 'N° de joueur' : 'N° de joueuse'}</span>
                                <p>{numInternational}</p>
                              </li>
                            )}
                          </ul>
                          <div>
                            <span
                              className="btn btn--primary btn--full mt-1 mt-md-4 mb-1"
                              style={{ marginRight: '1.5em' }}
                              onClick={() => this.setFavoritePlayer()}
                              role="button"
                              tabIndex="0"
                            >
                              <i className="icon icon-favorite is-inline" />
                              <span>{isFavoritePlayer ? 'Retirer des favoris' : 'Ajouter en favoris'}</span>
                            </span>
                            <a
                              href={`https://boutique.ffr.fr/?utm_source=site&utm_medium=button&utm_campaign=fichejoueur&utm_term=${title}`}
                              target="_blank"
                              className="btn btn--primary btn--full mt-1 mt-md-4 mb-1"
                              role="button"
                              tabIndex="0"
                              rel="noopener noreferrer"
                            >
                              <i className="icon icon-shirt is-inline" />
                              <span>{'Voir la boutique'}</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    {nombre_selections === -1 && content.length > 0 && <h3 className="mb-3 mt-6">Biographie</h3>}
                    {nombre_selections === -1 && this.renderTrueBlocs(content)}
                    <div>
                      {equipes && equipes.length > 0 && equipe_en_cours && equipe_en_cours.length > 0 && (
                        <TeamMenuDropdownMenu
                          withoutCategories={true}
                          hiddenMenuElements={equipes}
                          isMobile={false}
                          id={6}
                          level={'h2'}
                          classLevel={'mt-4'}
                          activeTeam={equipe_en_cours_une}
                          switchTeam={this.teamChange.bind(this)}
                        />
                      )}

                      {equipe_en_cours_une && equipe_en_cours_une.afficher_stats && (
                        <div>
                          <h3 className="mb-1 mt-6">{title_stats}</h3>
                          {(!equipe_en_cours_une ||
                            !equipe_en_cours_une.type_rugby ||
                            equipe_en_cours_une.type_rugby === 'XV') && (
                            <div className="player-stats box">
                              <div className="player-stats__item">
                                <p className="mb-1">{title_selections}</p>
                                <span>
                                  {equipe_en_cours_une.matchs
                                    ? equipe_en_cours_une.matchs.length + parseInt(selections_origine, 10)
                                    : 0 + parseInt(selections_origine, 10)}
                                </span>
                              </div>
                              <div className="player-stats__item">
                                <p className="mb-1">Transformations</p>
                                <span>
                                  {equipe_en_cours_une.transformations ? equipe_en_cours_une.transformations : '0'}
                                </span>
                              </div>
                              <div className="player-stats__item">
                                <p className="mb-1">Pénalités</p>
                                <span>{equipe_en_cours_une.penalites ? equipe_en_cours_une.penalites : '0'}</span>
                              </div>
                              <div className="player-stats__item">
                                <p className="mb-1">Essais</p>
                                <span>{equipe_en_cours_une.essais ? equipe_en_cours_une.essais : '0'}</span>
                              </div>
                              <div className="player-stats__item">
                                <p className="mb-1">Drops</p>
                                <span>{equipe_en_cours_une.drops ? equipe_en_cours_une.drops : '0'}</span>
                              </div>
                            </div>
                          )}
                          {equipe_en_cours_une &&
                            equipe_en_cours_une.type_rugby &&
                            equipe_en_cours_une.type_rugby === '7' && (
                              <p>
                                Retrouver les statistiques {genre === 'M' ? 'du joueur' : 'de la joueuse'} sur{' '}
                                <a
                                  href="https://www.world.rugby/sevens-series"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  World seven rugby
                                </a>
                              </p>
                            )}
                        </div>
                      )}
                    </div>
                    {matchs_joues.length > 0 &&
                      equipe_en_cours_une &&
                      equipe_en_cours_une.type_rugby &&
                      equipe_en_cours_une.type_rugby !== '7' &&
                      equipe_en_cours_une.matchs_joues &&
                      equipe_en_cours_une.matchs_joues.length > 0 && (
                        <PlayedGames matchs_joues={equipe_en_cours_une.matchs_joues} />
                      )}
                    {historique.length > 0 &&
                      equipe_en_cours_une &&
                      equipe_en_cours_une.type_rugby !== '7' &&
                      this.renderHistorique(historique)}
                    {joueurs_favs_news.length > 0 && (
                      <section className="section container">
                        <Link to={link_actus} className="link-chevron link-chevron--right section__link mt-1">
                          <span>Voir toutes les actualités {genre === 'M' ? 'du joueur' : 'de la joueuse'}</span>
                          <i className="icon icon-chevron-right"></i>
                        </Link>
                        <h2 className="mb-3">Ses actualités</h2>
                        <div className="box box--white card card--profile mes-favoris__news card--actus mt-6">
                          <div className="card__body">
                            <ul>{this.renderNewsPlayer()}</ul>
                          </div>
                        </div>
                        <Link to={link_actus} className="link-chevron mt-4 section__link">
                          <span>Voir toutes les actualités {genre === 'M' ? 'du joueur' : 'de la joueuse'}</span>
                          <i className="icon icon-chevron-right"></i>
                        </Link>
                      </section>
                    )}
                    {videos.length > 0 && (
                      <section className="section container">
                        <a
                          href={link_video}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="link-chevron link-chevron--right section__link mt-1"
                          data-label=""
                        >
                          <span>Voir toutes les vidéos {genre === 'M' ? 'du joueur' : 'de la joueuse'}</span>
                          <i className="icon icon-chevron-right"></i>
                        </a>
                        <h2 className="mb-3">En vidéos</h2>
                        <div className="news-slider">
                          <div className="news-slider__wrapper news-slider__wrapper--video">{this.renderYoutube()}</div>
                        </div>
                        <a
                          href={link_video}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="link-chevron mt-4 section__link"
                          data-label=""
                        >
                          <span>Voir toutes les vidéos {genre === 'M' ? 'du joueur' : 'de la joueuse'}</span>
                          <i className="icon icon-chevron-right"></i>
                        </a>
                      </section>
                    )}
                  </div>
                </article>
              </section>
            </div>
            <Sidebar sidebarContent={sidebar_content} />
          </div>
        </div>
      </>
    );
  }
}

export default withHelmet(TeamPlayer)((Helmet, pageProps) => {
  const {
    match: { params, url },
    joueur: { title, featured_media }
  } = pageProps;
  const teamTitle = pageProps.title;
  const meta = getMetaBySlug(url, params);
  const ogimage = featured_media ? featured_media.src : false;
  const ogimagetitle = featured_media ? featured_media.title : false;

  return (
    <Helmet>
      <title>{meta.title(title + ' - ' + teamTitle)}</title>
      <link rel={'canonical'} href={window.location.href} />
      <meta name={'description'} content={meta.description(title)} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={meta.title(title + ' - ' + teamTitle)} />
      <meta property={'og:description'} content={meta.description(title)} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {ogimage && ogimagetitle && <meta property={'og:image:title'} content={ogimagetitle} />}
    </Helmet>
  );
});
